import type { FaireProductEntity } from "../../entity_types/product";

export const p_twcahnh3yk: FaireProductEntity = {
  token: "p_twcahnh3yk",
  type: "product",
  name: "4oz. No. 8 Tomato + Herbs Candle",
  brandToken: "b_y6mta332qy",
  brandName: "Choice Blooms",
  imageUrl:
    "https://cdn.faire.com/fastly/3c2589e70c0a96ba26e6f16e7fce1ced2ea6ea7d025126fdef28cee9b5a4cdb1.jpeg",
  galleryImageUrls: [],
  priceDollars: 12,
  description:
    "No. 8 Tomato + Herbs candle made with hemp coconut blend wax and burns with a hemp wick all in a groovy translucent GREEN glass vessel.\n*Each vessel is unique in shape that is out of our control. \n\n3.5 oz in a 4 oz. vessel. 25-30 burn time hours \n\nThe Smell: No. 8 Tomato + Herbs- Herbaceous, earthy, masculine, medium/heavy intensity.\nTop: Tomato Leaf, Lemon Peel\nHeart: Lemongrass, Thyme, Basil\nBase: Moss, Green Leaves\n\nOur wax:\nA blend of natural hemp, soy, and coconut wax. This wax is clean-burning, biodegradable, + natural. Our wax is renewable + non-toxic. \n\nThe Wick: Made Of 100% Organic Hemp and 100% Beeswax. Little to no soot, non-toxic, and biodegradable. Contains NO lead, zinc, or other metals. Hemp wick burns slower than other wicks with a lower temperature flame and little to no smoke.",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:05.655Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
